import { Input } from 'almanac-ui/TextInputField/Input'
import Styles from 'screens/Campaign/CampaignContext/AddWebpageModal/AnchorType.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Icon } from 'blaze-ui/icons/Types'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'
import { LinkAngled } from 'blaze-ui/icons/20'
import { RadioBullet } from 'components/RadioGroup/RadioBullet'
import { useContext, useEffect, useState } from 'react'
import { RadioContext } from 'components/RadioGroup/RadioContext'
import { AnchorType as AnchorTypeOption } from 'types'
import { Checkbox } from 'blaze-ui/Checkbox/Checkbox'

interface AnchorTypeProps {
  title?: string
  icon?: Icon
  labels: string[]
  images?: string[]
  size?: 'sm' | 'md'
  isSelected: boolean
  placeholder: string
  onUrlChange: (url: string) => void
  urlInvalid: boolean
  urlErrorMessage?: string
  value: AnchorTypeOption
  withRadioBullet?: boolean
  examplesLabel?: string
  checkboxLabel?: string
  onCheckboxChange?: (checked: boolean) => void
  errorMessageClassName?: string
  allowSaveMedia?: boolean
}

export const AnchorType = (props: AnchorTypeProps) => {
  const state = useContext(RadioContext)
  const [url, setUrl] = useState('')
  const {
    title,
    icon: Icon,
    labels,
    images,
    size = 'md',
    isSelected,
    placeholder,
    onUrlChange,
    urlInvalid,
    urlErrorMessage,
    value,
    withRadioBullet = true,
    examplesLabel,
    checkboxLabel,
    onCheckboxChange,
    errorMessageClassName,
    allowSaveMedia = true,
  } = props

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUrl(e.target.value)
    onUrlChange(e.target.value)
  }

  const handleFocus = () => {
    state?.setSelectedValue?.(value)
  }

  useEffect(() => {
    if (isSelected) {
      onUrlChange(url)
    } else {
      setUrl('')
    }
  }, [isSelected]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={Styles.radioItem}>
      <div className={Styles.radioItemNameContainer}>
        {withRadioBullet && <RadioBullet size={25} isSelected={isSelected} />}
        {Icon && (
          <div className={Styles.iconContainer}>
            <Icon size={40} />
          </div>
        )}
        {title && (
          <div className={Styles.radioItemName}>
            <Heading level={size === 'sm' ? 5 : 4}>{title}</Heading>
          </div>
        )}
      </div>
      <div className={Styles.inputContainer}>
        <div className={Styles.inputIcon}>
          <LinkAngled size={20} />
        </div>
        <Input
          name="url"
          size="lg"
          value={url}
          placeholder={placeholder}
          onChange={handleUrlChange}
          onFocus={handleFocus}
        />
      </div>
      {urlInvalid && <div className={cx(Styles.errorMessage, errorMessageClassName)}>{urlErrorMessage}</div>}
      {checkboxLabel && (
        <div className={Styles.checkboxContainer}>
          <Checkbox onChange={onCheckboxChange} size={20}>
            <Text variant="primary" color="var(--dark-80)">
              {checkboxLabel}
            </Text>
          </Checkbox>
        </div>
      )}
      {images && (
        <>
          <div className={cx(Styles.examplesContainer, { [Styles.withoutCheckbox]: !checkboxLabel })}>
            {examplesLabel && (
              <Text variant="metadata" color="var(--dark-40)">
                {examplesLabel}
              </Text>
            )}
            <div className={cx(Styles.contentExamples, Styles[size])}>
              <div className={Styles.contentExample}>
                <img src={images[0]} alt={labels[0]} />
                <Text variant="secondary" color="var(--dark-60)">
                  {labels[0]}
                </Text>
              </div>
              <div className={Styles.contentExample}>
                <img src={images[1]} alt={labels[1]} />
                <Text variant="secondary" color="var(--dark-60)">
                  {labels[1]}
                </Text>
              </div>
              <div className={Styles.contentExample}>
                <img src={images[2]} alt={labels[2]} />
                <Text variant="secondary" color="var(--dark-60)">
                  {labels[2]}
                </Text>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
